/**
 * Central place for frontend error reporting.
 * Can be extended later to send to Sentry or a backend log endpoint.
 */
export function reportError(error: unknown, context?: string): void {
  const message = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;
  if (context) {
    console.error(`[FlowBoard ${context}]`, message, stack ?? '');
  } else {
    console.error('[FlowBoard]', message, stack ?? '');
  }
  // Future: send to Sentry or POST /api/client-errors
}
